import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";


const ProtectedRoute = ({ children }) => {
  const { user,loading } = useUserAuth();
  console.log("protected route")
  console.log(user)

  if (loading) {
    console.log("Loading ... ")
    return <p>Loading...</p>;
  }

  if (!user) {
    console.log("No user")
    return <Navigate to="/login" />;
  }
  else{
    console.log(user)
  }

  return children;  
};

export default ProtectedRoute;